import { effect, signal } from '@preact/signals-react';
import { SIDEBAR_STATE_STORAGE_KEY } from 'app/constants/storageKeys.ts';

function readInitialSidebarState(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return localStorage.getItem(SIDEBAR_STATE_STORAGE_KEY) === 'true';
  } catch (_error) {
    return false;
  }
}

/**
 * Read-only mirror of Redux `guiStateReducer.sideMenuOpen`, persisted to localStorage.
 * During migration, update the value through Redux dispatch; direct writes can desync state.
 */
export const sideBarOpenSignal = signal<boolean>(readInitialSidebarState());

effect(() => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(SIDEBAR_STATE_STORAGE_KEY, String(sideBarOpenSignal.value));
  } catch (_error) {
    // Ignore storage failures (private mode / disabled storage).
  }
});
